import { defineStore } from 'pinia';
import { watch } from 'vue';
import vuetify from '@/plugins/vuetify'; // Asegúrate de importar correctamente

export const useThemeStore = defineStore('theme', {
  state: () => ({
    theme: (localStorage.getItem('theme') as 'light' | 'dark' | 'system') || 'system',
  }),
  actions: {
    initTheme() {
      const applyTheme = (theme: 'light' | 'dark') => {
        vuetify.theme.global.name.value = theme;
      };

      const detectSystemTheme = () =>
        window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

      const applyCurrentTheme = () => {
        if (this.theme === 'system') {
          applyTheme(detectSystemTheme());
        } else {
          applyTheme(this.theme);
        }
      };

      // Apply on init
      applyCurrentTheme();

      // Watch for system changes
      window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
        if (this.theme === 'system') {
          applyTheme(event.matches ? 'dark' : 'light');
        }
      });
    },

    setTheme(theme: 'light' | 'dark' | 'system') {
      this.theme = theme;
      localStorage.setItem('theme', theme);
      this.initTheme(); // re-aplica el tema con la nueva preferencia
    }
  }
});
